import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { Layers } from '../constants.js';
import { Classes } from '@blueprintjs/core';
import * as Dialog from '@radix-ui/react-dialog';
import cx from 'classnames';
import { useTransition, config, animated } from '@react-spring/web';
import { useWindowSize } from 'react-use';
import { clamp } from 'ramda';
import { withClassNames } from '../../utils/with-classnames.js';
import { Button } from '../button/button.js';
import { Close16 } from '@carbon/icons-react';
import React__default, { useState, useEffect, forwardRef } from 'react';
import { usePopoverIsOpenShim } from '../popover/utils.js';
import { isIE11 } from '../../utils/isIE11.js';

var _excluded = ["container", "showCloseButton", "children", "trigger"],
    _excluded2 = ["includePadding", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Drawer = function Drawer(_ref) {
  var _props$open;

  var _ref$container = _ref.container,
      container = _ref$container === void 0 ? document.body : _ref$container,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
      children = _ref.children,
      trigger = _ref.trigger,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width; // copy of this state so we can track it if component is uncontrolled


  var _useState = useState((_props$open = props.open) !== null && _props$open !== void 0 ? _props$open : false),
      _useState2 = _slicedToArray(_useState, 2),
      localOpen = _useState2[0],
      setLocalOpen = _useState2[1];

  var openControls = usePopoverIsOpenShim({
    defaultOpen: props.defaultOpen,
    open: localOpen,
    onOpenChange: function onOpenChange(newState) {
      var _props$onOpenChange;

      setLocalOpen(newState);
      (_props$onOpenChange = props.onOpenChange) === null || _props$onOpenChange === void 0 ? void 0 : _props$onOpenChange.call(props, newState);
    }
  });
  useEffect(function () {
    if (props.open !== undefined) {
      setLocalOpen(props.open);
    }
  }, [props.open]);
  var drawerWidth = clamp(240, 360, width * 0.5);
  var transitions = useTransition(localOpen, {
    from: {
      right: drawerWidth * -1
    },
    enter: {
      right: 0
    },
    leave: {
      right: drawerWidth * -1
    },
    config: _objectSpread(_objectSpread({}, config.stiff), {}, {
      clamp: true
    }),
    immediate: isIE11
  });
  var dialogContentProps = {
    onInteractOutside: function onInteractOutside(event) {
      event.preventDefault();
      setLocalOpen(true);
    }
  };
  return /*#__PURE__*/React__default.createElement(Dialog.Root, _extends({}, props, openControls, {
    modal: false
  }), trigger && /*#__PURE__*/React__default.createElement(Dialog.Trigger, {
    asChild: true
  }, trigger), transitions(function (styles, item) {
    return item ? /*#__PURE__*/React__default.createElement(Dialog.Portal, {
      container: container,
      forceMount: true
    }, /*#__PURE__*/React__default.createElement(Dialog.Content, _extends({
      asChild: true,
      forceMount: true
    }, dialogContentProps), /*#__PURE__*/React__default.createElement(animated.div, {
      className: cx(Classes.DRAWER),
      style: _objectSpread(_objectSpread({}, isIE11() ? {
        right: 0
      } : styles), {}, {
        position: "absolute",
        zIndex: Layers.Popup
      })
    }, showCloseButton && /*#__PURE__*/React__default.createElement(Dialog.Close, {
      asChild: true
    }, /*#__PURE__*/React__default.createElement(Button, {
      minimal: true,
      icon: Close16,
      className: "vds-close"
    })), children))) : null;
  }));
};
Drawer.Header = withClassNames([Classes.DRAWER_HEADER, "bold vds-h4"], Dialog.Title);
Drawer.Body = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _ref2$includePadding = _ref2.includePadding,
      includePadding = _ref2$includePadding === void 0 ? true : _ref2$includePadding,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: Classes.DRAWER_BODY
  }, props, {
    ref: ref
  }), includePadding ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "1rem 1.5rem"
    }
  }, children) : children);
});
Drawer.Footer = withClassNames([Classes.DRAWER_FOOTER], "div");

export { Drawer };
//# sourceMappingURL=drawer.js.map
